import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { AddServicesToContractsWizardEffects } from './effects';
import * as fromAddServicesToContractsWizard from './reducer';

export function provideAddServicesToContractsWizardStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(fromAddServicesToContractsWizard.addServicesToContractsWizardFeatureKey, fromAddServicesToContractsWizard.reducer),
    provideEffects(AddServicesToContractsWizardEffects),
  ]);
}
